// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";

import type { OrgCloneWizardCloneStatus } from "src/types";

import { Text, VStack, CircularProgress } from "@chakra-ui/react";
import ServerErrorImg from "src/img/Server-Error.webp";
import * as styles from "./OrgCreationStatus.styles";

type Props = {
  cloneStatus: $NonMaybeType<OrgCloneWizardCloneStatus>,
  orgName: string,
};

export default function OrgCreationStatus({ cloneStatus, orgName }: Props) {
  if (cloneStatus.progress === "ongoing")
    return (
      <VStack sx={styles.container}>
        <VStack>
          <CircularProgress isIndeterminate size="52px" />
          <Text textStyle="displayXl">
            {i18n.t(k.CREATING)} {orgName} {i18n.t(k.ORG1)}
          </Text>
          <Text textStyle="displaySmall">{cloneStatus.state}</Text>
        </VStack>
      </VStack>
    );

  if (cloneStatus.progress === "completed") {
    return (
      <VStack sx={styles.container}>
        <Text textStyle="displayXl">
          {i18n.t(k.YOUR_ORG_IS_READY_YOU_WILL_BE)}
        </Text>
      </VStack>
    );
  }

  return (
    <VStack sx={styles.container}>
      <VStack>
        <img src={ServerErrorImg} />
        <Text textStyle="displayXl">{i18n.t(k.ERROR_CREATING_YOUR_ORG)}</Text>
        <Text textStyle="displaySmall">
          {i18n.t(k.SOMEONE_FROM_UNIFIZE_WILL_SOON)}
        </Text>
      </VStack>
    </VStack>
  );
}
